

const WordofWisdomeCard = () => {
    return (

        <>

            {/* <!--Sidebar Page Container--> */}
            <div className="sidebar-page-container">
                <div className="auto-container">
                    <div className="row clearfix">

                        {/* <!--Content Side / Blog Detail--> */}
                        <div className="content-side col-lg-12 col-md-12 col-sm-12">
                            <div className="post-details">
                                {/* <!--Blog Details--> */}
                                <div className="blog-details">


                                    <div className="lower-box">


                                        <div className="panel panel-primary">
                                            <div className="panel panel-heading">
                                                {/* <h4>Words of Wisdom - Question & Answer Session - #140   </h4> */}
                                                <h4>Words of Wisdom - Do not Judge  </h4>

                                            </div>

                                            <div className="panel panel-body">
                                                <div className='row'>
                                                    <div className="col-md-12">
                                                       {/* <!--<p> <img src="images/wordofwisdom.jpg" /></p>--> */}

                                                     <h4> <u>Do not Judge </u> </h4>

                                                     <p>
                                                     When someone relates a story or incident to you, you will most likely believe everything you hear. 
                                                     The words sound so sincere, after all. When A tells you a story, relates an incident, or complains about B,
                                                      you will think that a great injustice has been carried out. How shameful it is for B to behave so harshly,
                                                       even cruelly towards A, who is clearly an Angel!

                                                       <br/>

                                                       Then you hear the story from B, and you believe this story also. 
                                                       Now you start believing that A has not told you the truth. Now A seems to be the Devil and B, 
                                                       the Angel. What is going on here? Who is the Angel, and who is the Devil? 
                                                       Fact is that no individual is an angel, nor is anyone a devil. 
                                                       Everyone has virtues but also vices.
                                                       <br/>

                                                       If you were a judge, you would have to listen to both parties and then give judgment.
                                                        But you are not a judge. Therefore, stop judging. Understand human nature. We all tell our version of what really happened. 
                                                        This is why the court of law asks for evidence. 
                                                       The litigant must prove his point using evidence. Otherwise, it is all hearsay.
                                                    <br/>
                                                    Think of what you always do to prove your point. You also make yourself look perfect whereas the other person is completely biased, 
                                                    unfair, and even a tyrant. You tell a friend the reason you got fired, and the reason, according to you,
                                                     is a very mean employer who is bent on making your life miserable.
                                                     This said boss is a finicky nitpicker. What you don’t tell your friend is that your boss is a hard worker who expects you to work very hard also. What you leave out from the story is that you got fired because you are always late arriving to work and because you spend too much time by the water cooler.

                                                    <br/>

                                                    Leave the judging to the judicial judges, and to God, the ultimate Judge.
                                                     </p>

                                                     {/* <ul>
                                                        <li>
                                                            1. Because He gives without expecting anything from you.Everyone expects something back from you, even if it is a thank you note, a hug or a smile. God is the only one who keeps giving without any expectation.

                                                        </li>
                                                        <li>
                                                            2. Because you have every possible relationship with Him.In the world your mother is only your mother. She is not your father, brother, sister and child along with being your mother. God is mother, father, brother, sister, child and beloved. You are the spirit soul and you have each and every relationship with Him.
                                                        </li>
                                                        <li>
                                                            3. Because He is the only one who has always been with you. Wherever the soul goes after leaving the physical body, God goes along as well. He never leaves you alone for even the tiniest moment.
                                                        </li>
                                                        <li>
                                                            4.  Because He will always remain with you. Countless family members have been with you and now you are separated from them. Even the most intimate worldly relationship comes to an end one day. God, however, has always been with you and will always be by your side.
                                                        </li>

                                                        <li>
                                                            5. Because He forgives your countless offences.Even though His child has committed countless sins, God forgives everything if His child becomes truly repentant. 
                                                        </li>
                                                        <li> 
                                                            6. Because He is always looking at you without blinking.What if He blinks and at that very moment you decide to surrender to Him? The moment you surrender, He has to destroy your ignorance, burn your uncountable actions, and give you unlimited knowledge. So, He never blinks.
                                                        </li>
                                                        <li>
                                                            7.Because He has been infinitely patient with you.There is no end to His patience. Patiently He waits for you to run into His loving arms as you run in the opposite direction. But He waits and waits and waits. All because of love.
                                                        </li>

                                                        <li>
                                                            8.Because He is all-merciful.The only thing He knows to do is to shower mercy on one and all. Even as He punishes His children, He does it to grace them.
                                                        </li>
                                                        <li>
                                                            9. Because He never forgets you even though you forget Him.Although you may forget Him, He never forgets to grace you. He is the merciful mother who continues to love her child even though the child may be kicking her.
                                                        </li>

                                                        <li>
                                                            10. Because His love for you is immeasurable.It is absolutely impossible to measure the love God has for you. Because of that love He gives you the power of critical thinking. Because of that love He gives you fruits of your actions by taking note of every single thought of yours.
                                                        </li>

                                                     </ul> */}
                                                   
                                                      
                                                   
                                                     

                                                        <hr />
                                                        <p> Yours,</p>
                                                        <p> Didi Ji</p>
                                                        <p className="text-center"> Note: You may direct your spiritual questions to me
                                                            directly at</p>
                                                        <p className="text-center"> s_didi@radhamadhavsociety.org</p>


                                                    </div>

                                                </div>

                                            </div>


                                        </div>




                                    </div>






                                </div>





                            </div>

                        </div>


                    </div>
                </div>
            </div>
            {/* <!-- End Sidebar Page Container --> */}



        </>


    )

}

export default WordofWisdomeCard;